import { render } from "./reportIndex.vue?vue&type=template&id=974dc64e&scoped=true"
import script from "./reportIndex.vue?vue&type=script&lang=js"
export * from "./reportIndex.vue?vue&type=script&lang=js"

import "./reportIndex.vue?vue&type=style&index=0&id=974dc64e&lang=scss&scoped=true"

import exportComponent from "C:\\Jenkins\\workspace\\BT5\\rptweb\\feature_RPTWEB-3605_SERIALIZE-JAVASCRIPT_upgrade\\client\\databook\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-974dc64e"]])

export default __exports__